var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';

import { default as withStyles } from '../styles';

import { spacingXxSmall, colorBrandNeutral200, sizingXxLarge1 } from '../styles/tokens';

import classNames from 'classnames';

var colorBackgroundHeaderUtilityBar = '#3939B8';
var colorBackgroundHeaderUtilityBarThemed = colorBrandNeutral200;

var styles = function styles(theme) {
    return {

        root: {

            display: 'flex',
            height: '' + sizingXxLarge1,
            borderBottom: spacingXxSmall + ' solid ' + theme.palette.secondary.main,

            backgroundColor: colorBackgroundHeaderUtilityBar,

            '&.themed': {
                backgroundColor: colorBackgroundHeaderUtilityBarThemed
            }
        }

    };
};

/**
 * The utility area of a `HeaderBar`.
 *
 * @done true
 * @updated false
 * @versionAdded v0.2.4
 */

var HeaderUtilityBar = function (_React$Component) {
    _inherits(HeaderUtilityBar, _React$Component);

    function HeaderUtilityBar() {
        _classCallCheck(this, HeaderUtilityBar);

        return _possibleConstructorReturn(this, (HeaderUtilityBar.__proto__ || Object.getPrototypeOf(HeaderUtilityBar)).apply(this, arguments));
    }

    _createClass(HeaderUtilityBar, [{
        key: 'renderChildren',
        value: function renderChildren() {
            var _this2 = this;

            var children = [];

            if (this.props.SearchItem) {
                children.push(this.props.SearchItem);
            }

            children.push(React.Children.map(this.props.children, function (child) {
                return React.cloneElement(child, {
                    isUtility: true,
                    responsiveType: child.props.responsiveType || _this2.props.responsiveType
                });
            }));

            return children;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                classes = _props.classes,
                className = _props.className,
                isThemed = _props.isThemed;


            return React.createElement(
                'div',
                { className: classNames(classes.root, className, { 'themed': isThemed }) },
                this.renderChildren()
            );
        }
    }]);

    return HeaderUtilityBar;
}(React.Component);

HeaderUtilityBar.propTypes = {

    /**
     * At what breakpoint to hide all utility items on the header bar.
     *
     * Valid values are:
     *
     * - `none` - Never hide anything
     * - `small` - Hide items at the small breakpoint (and above)
     * - `medium` - Hide items at the medium breakpoint (and above)
     * - `large` - Hide items at the large breakpoint (and above)
     */
    responsiveType: PropTypes.string,

    /**
     * The items in the utility bar. Only accepts `HeaderBarItem`s.
     */
    children: function children(props, propName, componentName) {
        var error = void 0;
        var prop = props[propName];

        React.Children.forEach(prop, function (child) {
            if (child.type.displayName.indexOf('HeaderBarItem') === -1) {
                error = new Error(componentName + ' only accepts children of type HeaderBarItem');
            }
        });

        return error;
    },

    /** @ignore */
    isThemed: PropTypes.bool,

    /** @ignore */
    SearchItem: PropTypes.node,

    /** @ignore */
    classes: PropTypes.object.isRequired,

    /** @ignore */
    className: PropTypes.string

};

HeaderUtilityBar.defaultProps = {
    isThemed: false
};

export default withStyles(styles)(HeaderUtilityBar);